"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("./constants");

var _sx = _interopRequireDefault(require("./sx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Box = _styledComponents.default.div.withConfig({
  displayName: "Box",
  componentId: "nv15kw-0"
})(["", " ", " ", " ", ";"], _constants.COMMON, _constants.FLEX, _constants.LAYOUT, _sx.default);

var _default = Box;
exports.default = _default;